module.exports = __webpack_public_path__ + "static/media/Agenda9.2d5868f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda9.png
// module id = 1973
// module chunks = 0